import { testimonials } from "@/mocks/testimonials";

export default function Testimonials() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-medium text-foreground-500 uppercase tracking-wider">Community Trusted</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Reviews From
            <br />
            Global Shoppers
          </h2>
          <p className="mt-3 text-sm text-foreground-500">See why researchers trust our spreadsheet guides.</p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {testimonials.map((t, index) => (
            <div
              key={t.name}
              className={`bg-background-50 border border-background-200 rounded-xl p-6 ${
                index === testimonials.length - 1 ? "bg-secondary-50 border-secondary-200" : ""
              }`}
            >
              {/* Stars */}
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${
                      i < t.rating ? "ri-star-fill text-accent-500" : "ri-star-line text-foreground-300"
                    }`}
                  ></i>
                ))}
              </div>
              {/* Title */}
              <h4 className="font-heading text-lg font-semibold text-foreground-900">{t.title}</h4>
              {/* Body */}
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{t.body}</p>
              {/* Author */}
              <div className="flex items-center gap-3 mt-4 pt-4 border-t border-background-200">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-9 h-9 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}